import { Box, SxProps, Typography } from "@mui/material";
import React, { useState } from "react";
import { sortSelector, ISortTypes, changeSortType } from "redux/sort";
import { useSelector } from "react-redux";
import { UseAppDispatch } from "redux/store";
import { useTranslations } from "hooks/useTranslations";
import {
  Button,
  Drawer,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import CloseIcon from "@mui/icons-material/Close";
import { pushToDataLayer } from "@thekilroygroup/shared-ui";

export function SortSearchResults() {
  const {
    translations: { sort },
  } = useTranslations();
  const { sortType } = useSelector(sortSelector);
  const dispatch = UseAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const handleChange = (value: ISortTypes) => {
    pushToDataLayer(value, "Sort");
    dispatch(changeSortType(value));
  };

  const getLabel = (value: ISortTypes) => {
    return (
      <Typography variant="h6">
        {value === "flightTime"
          ? sort["fastest"]
          : value === "penaltyPoints"
            ? sort["best"]
            : sort["cheapest"]}
      </Typography>
    );
  };

  return (
    <>
      <Button
        sx={sxStyles.sortButtonMobile}
        variant={sortType === "penaltyPoints" ? "outlined" : "contained"}
        onClick={() => setIsOpen(!isOpen)}
      >
        <SortIcon />
        <Typography variant="h6">{sort.title}</Typography>
      </Button>

      <Drawer anchor="bottom" open={isOpen} onClose={() => setIsOpen(!isOpen)}>
        <IconButton className="closeButton" onClick={() => setIsOpen(!isOpen)}>
          <CloseIcon fontSize="medium" color="primary" />
        </IconButton>
        <Box sx={sxStyles.sortWrapperMobile}>
          <RadioGroup
            aria-labelledby="sort-radio-buttons-group-label"
            value={sortType}
            name="radio-buttons-group"
            onChange={(e, value) => handleChange(value as ISortTypes)}
          >
            <FormControlLabel
              sx={sxStyles.radioLabel}
              value="penaltyPoints"
              control={<Radio />}
              label={getLabel("penaltyPoints")}
            />
            <FormControlLabel
              sx={sxStyles.radioLabel}
              value="price"
              control={<Radio />}
              label={getLabel("price")}
            />
            <FormControlLabel
              sx={sxStyles.radioLabel}
              value="flightTime"
              control={<Radio />}
              label={getLabel("flightTime")}
            />
          </RadioGroup>
          <Typography variant="h5"></Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => setIsOpen(!isOpen)}
            sx={sxStyles.saveButton}
          >
            {sort.saveButtonText}
          </Button>
        </Box>
      </Drawer>
    </>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  sortButtonMobile: {
    "& svg": {
      mr: 1,
    },
    fontFamily: "fontFamily",
    textTransform: "capitalize",
    letterSpacing: "0",
    py: 0.5,
    px: 2,
    lineHeight: 1,
  },
  sortWrapperMobile: {
    pt: 6,
    pb: 4,
    px: 2,
  },
  radioLabel: {
    display: "flex",
    margin: 0,
    py: 2,
    px: 0,
    borderBottom: `1px solid`,
    borderBottomColor: "grey.200",
    "&:last-of-type": {
      borderBottom: `0px solid`,
    },
    "& .MuiRadio-root": {
      mr: 1,
      p: 0,
    },
  },
  saveButton: {
    mt: 5,
    width: 1,
  },
};
